/**
 * Reactive media query.
 *
 * For cases where a breakpoint has to change what is *rendered*, not just how
 * it looks. Hiding a form with CSS would leave its inputs in the DOM, where
 * autofill and screen readers still find them.
 */
import { ref, onMounted, onBeforeUnmount } from "vue";

export function useMediaQuery(query) {
  const matches = ref(false);
  let mql = null;

  const update = (event) => {
    matches.value = event.matches;
  };

  onMounted(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    mql = window.matchMedia(query);
    matches.value = mql.matches;
    mql.addEventListener("change", update);
  });

  onBeforeUnmount(() => {
    mql?.removeEventListener("change", update);
  });

  return matches;
}
